import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import VueClipboard from 'vue-clipboard2'
import Vuelidate from 'vuelidate';
import {db} from  '@/fb';
import colors from 'vuetify/lib/util/colors'
import '@mdi/font/css/materialdesignicons.css'
import VueCountdown from '@chenfengyuan/vue-countdown';
import VuePapaParse from 'vue-papa-parse'
import VueApexCharts from 'vue-apexcharts'
import Vue2Editor from "vue2-editor";

Vue.use(Vuetify);
Vue.use(VueClipboard)
Vue.use(Vuelidate);
Vue.use(VuePapaParse)
Vue.component(VueCountdown.name, VueCountdown);
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.use(Vue2Editor);
window.Apex.chart = { fontFamily: "Tajawal, sans-serif" };
const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  theme: {
    themes: {
      light: {
        primary: colors.grey.darken2,
        secondary: colors.grey.darken1,
        accent: colors.grey.black,
        error: colors.grey.accent3,
        info: colors.grey,
        success: colors.grey,
        warning: colors.grey,
      },
      dark: {
        primary: colors.blue.lighten3,
      },
    },
  },
})
export default vuetify
